/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TripsReportsRow,
    TripsReportsRowFromJSON,
    TripsReportsRowFromJSONTyped,
    TripsReportsRowToJSON,
} from './';

/**
 * ナビリポートリスト
 * @export
 * @interface TripsReportsList
 */
export interface TripsReportsList {
    /**
     * 
     * @type {Array<TripsReportsRow>}
     * @memberof TripsReportsList
     */
    trips?: Array<TripsReportsRow>;
}

export function TripsReportsListFromJSON(json: any): TripsReportsList {
    return TripsReportsListFromJSONTyped(json, false);
}

export function TripsReportsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripsReportsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trips': !exists(json, 'trips') ? undefined : ((json['trips'] as Array<any>).map(TripsReportsRowFromJSON)),
    };
}

export function TripsReportsListToJSON(value?: TripsReportsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trips': value.trips === undefined ? undefined : ((value.trips as Array<any>).map(TripsReportsRowToJSON)),
    };
}


